<app-select-filter-v2
        [loading]="findAllService.loading$ | async"
        [parentFormGroup]="parentFormGroup"
        [parentFormControlName]="parentFormControlName"
        [elements]="elements"
        (_onSingleSelectionChange)="singleSelectionChangeEvent.emit($event?.element)">
</app-select-filter-v2>

